export default __webpack_public_path__ + "static/media/mypage_banner_v2.e83f221b.png";